export const HEADER_MAX_VISIBLE_TAGS = 7
export const TABLE_MAX_VISIBLE_TAGS = 2

export const supportedUrls = ['/assets/all', '/assets/my', '/assets/shared', '/map']
